import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'gax-page-header-actions',
  templateUrl: './page-header-actions.component.html',
  styleUrl: './page-header-actions.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class PageHeaderActionsComponent {}
